/**
 * SPEED · GRÁFICOS RÁPIDOS
 *
 * Speed usa `skin: 1 | 2 | 3`.
 *
 * skin: 1 -> semicírculo de 180°, bases retas, escala interna
 * skin: 2 -> arco amplo de 270°, bases externas arredondadas, escala interna
 * skin: 3 -> arco amplo de 270°, bases externas arredondadas, escala externa
 *
 * Regras comuns:
 * - valor dinâmico em `series[].value`;
 * - `bands` definem as faixas de cor da escala completa;
 * - `ticks` define as marcações principais;
 * - `tick` continua disponível como atalho para escala regular;
 * - `minorDivisions` define subdivisões entre os ticks principais;
 * - `gap` no nível do chart separa módulos do compositor;
 * - `plotOptions.fast.gap: true` abre cortes retos nos ticks principais internos;
 * - min e max nunca recebem gap interno, pois são as extremidades físicas do arco;
 * - ponteiro neutro é o padrão; `needleColor` sobrescreve quando necessário;
 * - `unitLayout: 'auto'` põe `%` ao lado do valor, mantendo a unidade menor;
 * - outras unidades ficam embaixo e também mantêm tipografia secundária;
 * - `unitLayout` aceita `inline` e `stacked` para forçar apenas o posicionamento;
 * - tipografia final do SVG usa rem pelo normalizador global dos charts.
 *
 * Regra do tutorial: opção suportada e relevante que não está ativa no exemplo
 * permanece comentada no ponto em que seria configurada.
 */

export const speed1 = {
  element: 'chart',
  type: 'speed',
  skin: 1,
  title: 'Speed 1',
  chartBox: true,
  style: { alignSelf: 'start' },

  plotOptions: {
    fast: {
      min: 0,
      max: 200,
      gap: true,

      ticks: [0, 50, 100, 150, 200],
      // tick: 50,
      minorDivisions: 10,

      thickness: 0.17,

      // tickFontSize: 10,
      // tickColor: '#a6adb7',
      // tickTextColor: '#f0f3f6',
      // gapSize: 3,

      // needleColor sobrescreve o ponteiro neutro definido pelo tema.
      // needleLengthScale: 1.14,
      // needleWidth: 10,
      // needleTipWidth: 1.6,

      // valueColor: '#f5f7fa',
      // unitColor: '#aab4c1',
      // unitLayout: 'inline', // auto empilha km/h; inline muda só a posição.

      bands: [
        { from: 0, color: '#f2b52b' },
        { from: 100, color: '#ee8637' },
        { from: 150, color: '#d94b3b' }
      ]
    }
  },

  series: [
    {
      subtitle: 'Atual',
      unit: 'km/h',
      value: 46,
      options: { dataLabels: { format: '{value}', fixed: 0 } }
    }
  ]
};

export const speed2 = {
  element: 'chart',
  type: 'speed',
  skin: 2,
  title: 'Speed 2',
  chartBox: true,
  style: { alignSelf: 'start' },

  plotOptions: {
    fast: {
      min: 0,
      max: 100,
      gap: true,

      ticks: [0, 20, 40, 60, 80, 100],
      // tick: 20,
      minorDivisions: 10,

      thickness: 0.18,

      // tickFontSize: 10,
      // tickColor: '#a6adb7',
      // tickTextColor: '#f0f3f6',
      // gapSize: 3,

      // needleColor sobrescreve o ponteiro neutro definido pelo tema.
      // needleLengthScale: 1.10,
      // needleWidth: 9,
      // hubRadius: 4.5,
      // hubInnerFill: '#121619',

      // valueColor: '#f5f7fa',
      // unitColor: '#aab4c1',
      // unitLayout: 'inline', // auto empilha km/h; inline muda só a posição.

      bands: [
        { from: 0, color: '#58c53f' },
        { from: 60, color: '#f0e915' },
        { from: 80, color: '#ed5960' }
      ]
    }
  },

  series: [
    {
      subtitle: 'Atual',
      unit: 'km/h',
      value: 60,
      options: { dataLabels: { format: '{value}', fixed: 0 } }
    }
  ]
};

export const speed3 = {
  element: 'chart',
  type: 'speed',
  skin: 3,
  title: 'Speed 3',
  chartBox: true,
  style: { alignSelf: 'start' },

  plotOptions: {
    fast: {
      min: 0,
      max: 100,
      gap: true,

      ticks: [0, 20, 40, 60, 80, 100],
      // tick: 20,
      minorDivisions: 10,

      thickness: 0.14,

      // tickFontSize: 10,
      // tickColor: '#a6adb7',
      // tickTextColor: '#f0f3f6',
      // gapSize: 3,

      // needleColor sobrescreve o ponteiro neutro definido pelo tema.
      // needleLengthScale: 1.05,
      // needleWidth: 2.5,
      // hubRadius: 4.5,
      // hubInnerFill: '#121619',

      // valueColor: '#f5f7fa',
      // unitColor: '#aab4c1',
      // unitLayout: 'inline', // auto empilha km/h; inline muda só a posição.

      // A terceira referência usa somente duas faixas no arco: clara até 60
      // e roxa escura de 60 até 100. A escala fica completamente por fora.
      bands: [
        { from: 0, color: '#d8bce9' },
        { from: 60, color: '#7c2ca8' }
      ]
    }
  },

  series: [
    {
      subtitle: 'Atual',
      unit: 'km/h',
      value: 100,
      options: { dataLabels: { format: '{value}', fixed: 0 } }
    }
  ]
};

export const speedQuickCharts = [speed1, speed2, speed3];